/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Warning } from '@carbon/react/icons';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { messages } from './messages';

export const InstanceLabel = instance => {
  const intl = useIntl();

  // some callers nest the instance
  const inst = instance.instance ? instance.instance : instance;

  if (!inst.unavailable) {
    return inst.name || (inst.entity?.name ?? 'missingName');
  }

  return (
    <div className="unavailable-instance-wrapper--warning--unavailable">
      <Warning
        size={16}
        aria-label={intl.formatMessage(messages.instanceUnavailable)}
      />
      <span className="unsupported-instance-name">
        {inst.name || inst.entity.name}
      </span>
      <span className="unsupported-instance">
        <FormattedMessage {...messages.unavailable} />
      </span>
    </div>
  );
};
